import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Setup from "./pages/Setup";
import Iframe from "./pages/Iframe";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/setup" element={<Setup />} />
        <Route path="/customPanel" element={<Iframe />} />
      </Routes>
    </Router>
  );
}

export default App;
